import React from 'react';

const positionColors = {
	quarterback: '#9647B8',
	'running back': '#15997E',
	'wide receiver': '#E67E22',
	'tight end': '#2980B9'
};

const positionAbbreviations = {
	quarterback: 'QB',
	'running back': 'RB',
	'wide receiver': 'WR',
	'tight end': 'TE'
};

const DraftedPlayerCard = ({
	player,
	handlePlayerClick,
	handleTeamClick,
	handleOpenRosterPlayerNote,
	handleOpenChampionshipWeeksModal
}) => {
	if (!player) return null;

	const { first_name, last_name, position, image_url, team } = player;
	const bgColor = positionColors[position] || '#333';
	const positionLabel =
		positionAbbreviations[position] || position.toUpperCase();

	return (
		<div
			className="w-48 my-2 p-4 rounded-2xl shadow-lg text-white text-center"
			style={{ backgroundColor: bgColor }}
		>
			{/* Player Image */}
			<img
				src={`${image_url}?w=50&h=50`}
				alt={`${first_name} ${last_name}`}
				className="w-12 h-12 mx-auto rounded-full object-cover border border-white"
				style={{
					backgroundColor: '#fff'
				}}
			/>
			{/* Player Name with Click Event */}
			<div>
				<div
					className="text-lg hover:underline cursor-pointer"
					onClick={() => handlePlayerClick(player)}
				>
					{first_name} {last_name}
				</div>
				{/* Team Name with Click Event */}
				<div>
					<div
						className="text-sm text-white-500 hover:underline cursor-pointer"
						onClick={() => handleTeamClick(team)}
					>
						{team.name}
					</div>
				</div>
			</div>
			{/* Icons for Notes and Championship Weeks */}
			<div className="mt-2">
				<i
					className="fa-solid fa-note-sticky text-white hover:text-white fa-lg rounded mr-3 cursor-pointer"
					alt="Manager Player Notes"
					onClick={() => handleOpenRosterPlayerNote(player)}
				/>
				<i
					className="fa-solid fa-yin-yang text-white hover:text-white fa-lg rounded mr-3 cursor-pointer"
					alt="Championship Weeks"
					onClick={() => handleOpenChampionshipWeeksModal(player)}
				/>
			</div>
		</div>
	);
};

export default DraftedPlayerCard;
